import React from 'react';
import { Navigate } from 'react-router-dom';

export default () => {
	return {
		index: true,
		element: <Navigate to="fee-structure" replace />,
	};
};
